module.exports = __webpack_public_path__ + "media/components/assets/icons/back_btn-838af9fe910d6fc5fe54440f230fb351.svg";